import React from 'react'
import ReactBootstrapModal from '../../../common/modals/ReactBootstrapModal'
import { useState } from 'react';
import { ModalSession } from '../../../common/modals/ModalSession';
import { useSelector } from 'react-redux';
import logger from '../../../../utils/logger';


export const Header = ({ isAdmin = true }) => {

    const list = useSelector((data) => data.commonData.lista.myInfo)



    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(false);

    const showBootstrapModal = (id) => {
        setBootstrapModalStatus(id);
    }

    const closeBootstrapModal = () => {
        setBootstrapModalStatus(null);
    };

    const toggleModalShow = () => {
        setBootstrapModalStatus(!bootstrapModalStatus);
    }

    return (
        <header className="header">
            <p className="header-title">
                {isAdmin ?
                    'TPA Sitio de Administración'
                    :
                    ''

                }
            </p>
            <nav className="nav modalSesionClose" id="nav" onClick={toggleModalShow}>

                <span className="material-symbols-outlined mI-User notranslate" aria-hidden="true" role="none">account_circle</span>

                {list &&

                    <p>{list.name}</p>
                }


                <ReactBootstrapModal
                    toggleModal={toggleModalShow}
                    showModal={bootstrapModalStatus}
                    dialogClass={'modalDialogStyle'}
                    modalClass={'modalSesion'}
                >

                    <ModalSession />
                </ReactBootstrapModal>

            </nav>


        </header>
    )
}
